import React from "react";
import { useAuthentication } from "@planzone/view-models";
import { useFilesCache } from "@components/cache";
import { Loader } from "@common/loader";
import { AddIcon } from "../addIcon";
import { Props } from "./types";
import styles from "./styles.scss";

function Image({ value, className }: Props) {
  const cache = useFilesCache();
  const { token } = useAuthentication().account;
  const [state, setState] = React.useState({
    loadingState: "loadingCache",
    uri: "",
  });

  React.useEffect(() => {
    state.loadingState === "loadingCache" &&
      cache
        .get(value)
        .then((blob) =>
          setState({
            loadingState: "startLoading",
            uri: URL.createObjectURL(blob),
          }),
        )
        .catch(() => setState({ loadingState: "none", uri: "" }));
  }, [value, state.loadingState === "loadingCache"]);

  React.useEffect(() => {
    if (state.loadingState !== "none") return;

    const controller = new AbortController();
    const signal = controller.signal;

    fetch(`/docs/files/documents/${value}/content`, {
      method: "get",
      headers: {
        Authorization: `Bearer ${token}`,
      },
      signal,
    })
      .then((res) => res.blob())
      .then((blob) => {
        const uri = URL.createObjectURL(blob);

        URL.revokeObjectURL(state.uri);

        try {
          cache.add(value, blob);
        } catch (e) {}

        setState({ loadingState: "startLoading", uri });
      })
      .catch(() => {
        fetch(value, {
          method: "get",
          headers: {
            Authorization: `Bearer ${token}`,
          },
          signal,
        })
          .then((res) => res.blob())
          .then((blob) => {
            const uri = URL.createObjectURL(blob);

            URL.revokeObjectURL(state.uri);

            try {
              cache.add(value, blob);
            } catch (e) {}

            setState({ loadingState: "startLoading", uri });
          })
          .catch(() => {
            setState((s) => ({
              ...s,
              loadingState: "failure",
            }));
          });
      });

    return () => {
      controller.abort();
    };
  }, [value, state.loadingState === "none"]);

  React.useEffect(() => {
    if (state.loadingState === "startLoading") {
      const img = new window.Image();

      img.src = state.uri;

      img.onload = () => {
        setState({ ...state, loadingState: "success" });
        img.remove();
      };
      img.onerror = () => {
        setState({ ...state, loadingState: "failure" });
        img.remove();
      };
    }
  }, [state.loadingState, state.uri]);

  return state.loadingState === "pending" ? (
    <div className={className}>
      <Loader />
    </div>
  ) : state.loadingState === "failure" ? (
    <AddIcon className={styles.addIcon} />
  ) : (
    <img className={className} src={state.uri} alt="" />
  );
}

export { Image };
